import Faq from "../../components/home/Faq";
import { useTranslation } from "react-i18next";

import Member from "../../components/home/Member";
import { useState } from "react";
import Register from "./Register";
import Reasons from "../../components/home/Reasons";
import Footer from "../../layout/Footer";
import Competitors from "./Competitors";
import Main from "./Main";
import HR from "../../assets/higherRight.svg"
import LR from "../../assets/Lower Right.png"
// import CTA from "../../assets/wave.svg"
import Reasons1 from "@components/home/Reasons1";
import StepsComponent from "@components/home/StepsComponent";
import { scale } from "framer-motion";
import { Import } from "lucide-react";
import Partner from "./Partner";
import Partners from "./Partners";

const Home = ({ handleLogin }) => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [activeForm, setActiveForm] = useState("in"); // "in" or "up"

  const openModal = (formType = "in") => {
    setActiveForm(formType);
    setShow(true);
  };

  return (

<section className="w-100" >
    <Main openModal={openModal} />
      <Register
        show={show}
        setShow={setShow}
        handleLogin={handleLogin}
        activeForm={activeForm}
        setActiveForm={setActiveForm}
      />
   
    
      
   <div
        className="position-relative d-none d-xl-grid"
        style={{ placeItems: "center" }}
      >
        <img
          src={HR}
          className="img-fluid w-75 ms-auto"
          alt=""
          style={{
            opacity: 0.5,
            gridArea: "1 / 1",
          }}
        />

        <div
          style={{
            gridArea: "1 / 1",
            zIndex: 2,
          }}>
          <Reasons1 />
        </div>
      </div> 

      {/* Mobile */}
      <div className="d-block d-xl-none">
        <Reasons1 />
      </div> 


      <div className="">

        <Reasons t={t} />
        <div
          className="position-relative d-none d-xl-grid mt-5 pt-5"
          style={{
            placeItems: "start",
          }}
        >
     
          <img
            src={HR}
            className="img-fluid w-75 me-auto"
            alt=""
            style={{
              opacity: 0.5,
              rotate: "180deg",
              gridArea: "1 / 1",
            }}
          />

        
          <div
            className="pt-5 mt-5"
            style={{
              gridArea: "1 / 1",
              zIndex: 2,
              width: "100%",
            }}
          >
            <Competitors t={t} />

          </div>
        </div>
        <Partners t={t} />



        
   
        <div className="d-block d-xl-none container-xl">
          <Competitors t={t} />
          <Partners t={t} />
        </div>

        <div className="container-xl">
          <StepsComponent t={t} />

          <Faq />
          <Member t={t} openModal={openModal} />
        </div>

      </div>


      <Footer t={t} />  </section>

   
  );
};

export default Home;
